import { Injectable } from "@angular/core";
import { Profile } from "@shared/interfaces/profile.model";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";

@Injectable()
export class ProfileService {
  constructor(private readonly httpHelperService: HttpHelperService) {}

  public getProfileDetails(userId: string): Observable<Profile> {
    return this.httpHelperService.get(`/user/profile/detail?userId=${userId}`);
  }

  public getELearningLOV(userId: string): Observable<any> {
    return this.httpHelperService.get(`/user/elearning/lov?userId=${userId}`);
  }
  public searchELearning(payload): Observable<any> {
    return this.httpHelperService.get(
      `/user/elearning/list?agentCode=${payload.agentCode}&trainingYear=${payload.year}&userId=${payload.userId}`,
    );
  }

  public changePassword(body: any) {
    return this.httpHelperService.postWithOptions("/user/password/save", body, {
      baseUrl: this.httpHelperService.resolveAlphaSatBaseUrl(),
    });
  }

  public updateProfileDetails(body: any) {
    return this.httpHelperService.post("/user/profile/save", body);
  }

  public downloadProfileCpdTraining(payload): Observable<any> {
    const cpdDeatils = payload.isAdmin
      ? "CDPTrainingSummary"
      : "CDPTrainingDetail";
    return this.httpHelperService.getURL(
      `/user/report/generate/pdf/${cpdDeatils}?branchCode=${payload.branchCode}&agentCode=${payload.agentCode}&trainingYear=${payload.trainingYear}&shortfall=${payload.shortfall}`,
    );
  }

  public getFilteredAgentList(payload) {
    return this.httpHelperService.post("/user/elearning/agents", payload);
  }
}
